import React from "react";
const echo = process.env.PUBLIC_URL + "/assets/walkthrough/echo_avatar.svg";

function IntroD({ text }) {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        boxSizing: "border-box",
        padding: "24px 8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "10px",
        transform: "translateX(-4vh)",
      }}
    >
      <div
        style={{
          width: 70,
          height: 70,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0B9C57",
          borderRadius: 12,
          boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
          marginRight: "20px",
        }}
      >
        <img src={echo} alt="ECHO Logo" style={{ width: 50, height: 50 }} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
          padding: "36px 50px",
          minWidth: 320,
          maxWidth: 900,
        }}
      >
        {/* Message box */}
        <div
          style={{
            fontSize: 32,
            color: "#222",
            fontWeight: 400,
            lineHeight: 1.4,
            wordBreak: "break-word",
          }}
        >
          {text}
        </div>
      </div>
    </div>
  );
}

export default IntroD;
